import React, { useState } from "react";
import QuestionsList from "./components/QuestionsList";
import { v4 as uuidv4 } from "uuid";
import "./App.css";

const App = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [clicked, setClicked] = useState(false);
  const [showScore, setShowScore] = useState(false);
  const [correctQuestions, setCorrectQuestions] = useState("");
  const [respCurrentQues, setRespCurrentQues] = useState(false);
  const [mensFim, setMensFim] = useState("Você Acertou: ");
  const [totCert, setTotCert] = useState("Score: ");
  const [listCert, setListCert] = useState("Right questions: ");
  const [conclusao, setConclusao] = useState("Qual será a Conclusão ");


  const handleCorrectAnswer = (isCorrect) => {
    if (isCorrect) {
      if (!respCurrentQues) {
        setScore(score + 1);
        setCorrectQuestions(correctQuestions + (currentQuestion + 1) + ", ");
      }
      setRespCurrentQues(true);
    } else {
      setRespCurrentQues(true);
    }
    setClicked(true);
  };



  const handleNextQuestion = () => {
    setClicked(false);

    setRespCurrentQues(false);

    if (currentQuestion < QuestionsList.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
    
            
      setShowScore(true);
    }
  };
  
  
  const handleNota = () => {  /** Below calculation of the percentage of correct questions  */
      var perac = (((score * 100)/QuestionsList.length).toFixed(0));
      
      let button = document.querySelector(".nota-button");
      button.disabled = true;

      
      /** Code JS Pregress Bar ******** */
      var i = 0;
        if (i === 0) {
    i = 1;
    var elemmyBar = document.getElementById("myBar");
    var elemscorse = document.getElementById("score-section");
    var elemcorrquest = document.getElementById("correct-questions");
    var elemtxtConcl = document.getElementById("txtConcl");
    var width = 1;
    var id = setInterval(frame, 50);
    function frame() {
      if (width >= perac) {
       concl();
       mensfim()
        clearInterval(id);
        i = 0;
      } else {           
           width++;
              elemmyBar.style.background = 'red';
              elemscorse.style.color = 'red';
              elemcorrquest.style.color = 'red';
              elemtxtConcl.style.color = "red";
           if( width >= 50){ elemmyBar.style.background = '#d35400' };
           if( width >= 60){ 
              elemmyBar.style.background = '#3498db';
              elemscorse.style.color = '#3498db';
              elemcorrquest.style.color = '#3498db';
              elemtxtConcl.style.color = "#3498db";
           }           
           if( width >= 80){ 
               elemmyBar.style.background = 'green';
               elemscorse.style.color = 'green';
               elemcorrquest.style.color = 'green';
               elemtxtConcl.style.color = "green";               
                };
           elemmyBar.style.width = width + "%";
        
      }
    }
  }  
  
  function mensfim() {
      setMensFim("Você Acertou: " + (((score * 100)/QuestionsList.length).toFixed(0)) + "%");      
      setListCert("Right questions: " + correctQuestions);
      setTotCert("Score: " + score + "/" + QuestionsList.length );
  }
  
  
  
      /** End Code JS Pregress Bar ******************* */ 
                 
      function concl() {
        
        console.log(9, perac)
        if(perac < 60){        
        setConclusao("Nota insuficiente, você foi reprovado!!!");
        }
        else{
        setConclusao("Parabéns!!! Você foi aprovado!!!");
        }
      }
     
      
      
      };
  
  
  

  return (
    <div className="app-wrapper">
      {showScore ? (
        <div>
          <div className="completed">Game over!</div>
          <br />
          <div id="square-final">
          
          
          <div>
            <button
              className="nota-button" onClick={handleNota}
             
            >
              Veja sua nota
            </button>
          </div>          
             
             
       
            <div id="score-section">
                     {totCert}
             
                           <br />  
             {mensFim}
            </div>
            <br />
            <br />
            <div id="correct-questions">
               {listCert}
              
            </div>
            
            
            <br />
            <br />            
            
            <div id="myProgress">
  		<div id="myBar"></div>
	    </div>

            <br />
            <br />    
            
            <div id="txtConcl">
              {conclusao}
            </div>

	    
          </div>
        </div>
      ) : (
        <div>
          <div className="title-quiz">QUIZ</div>

          <div className="answer-instrutions">
            Attention: only the first answer counts
          </div>

          <div className="question-section-wrapper">
            <div className="question-count">
              Question {currentQuestion + 1} of {QuestionsList.length}
            </div>
            <div className="question">
              {QuestionsList[currentQuestion].question}
            </div>
          </div>
          <div className="answer-section-wrapper">
            {QuestionsList[currentQuestion].answersList.map((answerOption) => (
              <li className="answer-list" key={uuidv4()}>
                <button
                  disable={clicked}
                  className={`answer-button ${
                    clicked && answerOption.isCorrect ? "correct" : ""
                  }`}
                  onClick={() => handleCorrectAnswer(answerOption.isCorrect)}
                >
                  {answerOption.answer}
                </button>
              </li>
            ))}
          </div>
          <div>
            <button
              className="next-button"
              onClick={handleNextQuestion}
              disabled={!clicked}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
